<script>

import MediaQuery from "./MediaQuery.svelte";

</script>

  <header class="viewport-header">
    <video playsinline autoplay muted loop poster="./pics/desktop/7.webp" id="bgvid">
      <source src="./pics/azovstal.mp4" type="video/mp4">
    </video>
  </header>

  
  <style>
video {
  width: 100vw;
  height: 100vh;
  object-fit:cover;
}

@media screen and (max-width: 550px) {
  video {
    object-fit:cover;
    }
}

.viewport-header {
  position: relative;
  height: 100vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

  </style>